export type AiConsumerRole = 'overseer' | 'ux' | 'core' | 'worker';

/** brunel.ai_connection_role_bindings: which connection a role uses on which computer. */
export interface AiConnectionRoleBindingRow {
  readonly org_id: string;
  readonly consumer_role: AiConsumerRole;
  readonly connection_key: string | null;
  readonly node_id: string | null;
  readonly account_ref: string;
  readonly external_session_id: string | null;
  readonly updated_at: string;
}

/** What Brunel stored under 'core' was the one Reviewer's route. */
export function consumerRoleLabel(role: AiConsumerRole): string {
  if (role === 'overseer') return 'Main Overseer';
  if (role === 'ux') return 'Observer UX';
  if (role === 'core') return 'Reviewer';
  return 'Worker';
}
